var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M852.4 1007.7H126.6V606.8l318.2-279.5 44.7-39.2 362.9 318.7z",
    fill: "#FCD170"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M852.4 1017.7H126.6c-5.5 0-10-4.5-10-10v-401c0-2.9 1.2-5.6 3.4-7.5l362.9-318.7c3.8-3.3 9.4-3.3 13.2 0L859 599.3c2.2 1.9 3.4 4.6 3.4 7.5v401c0 5.4-4.5 9.9-10 9.9z m-715.8-20h705.8V611.3L489.5 301.4 136.6 611.3v386.4z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8 689.8l463.7-401.1",
    fill: "#FCD170"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8 699.8c-2.8 0-5.6-1.2-7.6-3.5-3.6-4.2-3.2-10.5 1-14.1L483 281.1c4.2-3.6 10.5-3.2 14.1 1 3.6 4.2 3.2 10.5-1 14.1L32.3 697.4c-1.9 1.6-4.2 2.4-6.5 2.4z",
    fill: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M946.5 689.8L482.8 288.7",
    fill: "#FCD170"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M946.5 699.8c-2.3 0-4.6-0.8-6.5-2.4L476.3 296.2c-4.2-3.6-4.6-9.9-1-14.1 3.6-4.2 9.9-4.6 14.1-1l463.7 401.2c4.2 3.6 4.6 9.9 1 14.1-2 2.3-4.8 3.4-7.6 3.4z",
    fill: ""
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M625.4 1007.7H353.6V703.5c0-2.4 1.9-4.3 4.3-4.3h263.3c2.4 0 4.3 1.9 4.3 4.3v304.2z",
    fill: "#D64F34"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M625.4 1017.7H353.6c-5.5 0-10-4.5-10-10V703.5c0-7.9 6.4-14.3 14.3-14.3h263.3c7.9 0 14.3 6.4 14.3 14.3v304.3c-0.1 5.4-4.6 9.9-10.1 9.9z m-261.8-20h251.8V709.2H363.6v288.5z",
    fill: ""
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M996.9 441.3c0 167.7-98.7 236.4-220.5 236.4S555.8 609 555.8 441.3 776.3 3 776.3 3s220.6 270.6 220.6 438.3z",
    fill: "#FFFFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M776.3 751c-11.9 0-21.5-9.6-21.5-21.5V182.1c0-11.9 9.6-21.5 21.5-21.5s21.5 9.6 21.5 21.5v547.4c0 11.9-9.6 21.5-21.5 21.5z",
    fill: "#FFFFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M961.6 437.5c0 146.2-83 206.1-185.3 206.1S591 583.7 591 437.5s185.3-382 185.3-382 185.3 235.8 185.3 382z",
    fill: "#60C13D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M776.3 653.6c-56.6 0-104.3-17.7-138.1-51.1-38-37.6-57.2-93.1-57.2-164.9 0-62.5 31.6-146.9 94.1-251C721.2 109.7 768 50 768.5 49.4c1.9-2.4 4.8-3.8 7.9-3.8s6 1.4 7.9 3.8c0.5 0.6 47.2 60.3 93.4 137.2 62.4 104.1 94.1 188.5 94.1 251 0 71.8-19.3 127.3-57.2 164.9-33.9 33.4-81.7 51.1-138.3 51.1z m0-581.6c-15.1 20.1-49.8 67.8-84.2 125-41.5 69.4-91.1 167.3-91.1 240.5 0 66.3 17.3 117 51.3 150.7 29.9 29.6 72.8 45.3 124 45.3s94.1-15.7 124-45.3c34-33.8 51.3-84.5 51.3-150.7 0-73.2-49.5-171.2-91.1-240.5-34.3-57.2-69-104.9-84.2-125z",
    fill: ""
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M776.3 722.6c-5.5 0-10-4.5-10-10V165.2c0-5.5 4.5-10 10-10s10 4.5 10 10v547.4c0 5.5-4.5 10-10 10z",
    fill: ""
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M776.3 407.1c-2.7 0-5.5-1.1-7.4-3.3l-95.4-106.2c-3.7-4.1-3.4-10.4 0.8-14.1 4.1-3.7 10.4-3.4 14.1 0.8l95.4 106.2c3.7 4.1 3.4 10.4-0.8 14.1-1.9 1.7-4.3 2.5-6.7 2.5zM776.3 588.4c-2.8 0-5.6-1.2-7.6-3.5L634.6 427.4c-3.6-4.2-3.1-10.5 1.1-14.1 4.2-3.6 10.5-3.1 14.1 1.1l134.1 157.5c3.6 4.2 3.1 10.5-1.1 14.1-1.9 1.6-4.2 2.4-6.5 2.4zM776.3 300.9c-2.6 0-5.1-1-7.1-2.9-3.9-3.9-3.9-10.2 0-14.1l64.7-64.7c3.9-3.9 10.2-3.9 14.1 0 3.9 3.9 3.9 10.2 0 14.1L783.4 298c-2 1.9-4.5 2.9-7.1 2.9zM782.6 491.4c-2.7 0-5.5-1.1-7.4-3.3-3.7-4.1-3.3-10.4 0.8-14.1l94.3-84.5c4.1-3.7 10.4-3.3 14.1 0.8 3.7 4.1 3.3 10.4-0.8 14.1l-94.3 84.5c-1.9 1.6-4.3 2.5-6.7 2.5z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a189bb5e784865e4c9a15caa4187e897.svg";
export { ForwardRef as ReactComponent };